module.exports = __webpack_public_path__ + "img/wb2t0.8928ab6d.png";